import React from "react";
import {Icon} from "@aws-amplify/ui-react";

import EiaDialog from "./dialogs/EiaDialog";
import {RiShareForward2Fill} from "react-icons/ri";
import EiaTextField from "./EiaTextField";
import EiaCopyButton from "./EiaCopyButton";
import EiaButton from "./EiaButton";

const EiaShareButton = function (props) {

    const {title, link} = props

    const [openDialog, setOpenDialog] = React.useState(false);

    return (
        <div>
            <EiaDialog open={openDialog} onClose={() => setOpenDialog(false)} title={title} fullWidth={true}>
                <EiaTextField isReadOnly={true}
                              label="Link" value={link} outerEndComponent={
                    <EiaCopyButton textToCopy={link} />
                }>
                </EiaTextField>
            </EiaDialog>
            <EiaButton size={"large"} variation={"link"}
                    onClick={() => setOpenDialog(true)}
            >
                <Icon ariaLabel="Javascript" as={RiShareForward2Fill}/>
            </EiaButton>
        </div>
    )
}
export default EiaShareButton;